import { DISABLE_CLICK_AWAY_PROP_NAME } from './constants';

export const getDisableClickAwayProps = () => ({
    [DISABLE_CLICK_AWAY_PROP_NAME]: true,
});

/**
 * @returns true if some element in component tree contain `DISABLE_CLICK_AWAY_PROP_NAME` attribute,
 */
export function isClickAwayDisabledInTheComponentTree(event: Event) {
    return event
        .composedPath()
        .slice(0, -4) // remove window, document, html and body element from the path
        .some((eventTarget) => {
            const element = eventTarget as Element;
            return element.getAttribute(DISABLE_CLICK_AWAY_PROP_NAME) === 'true';
        });
}
